const gql = {
  query: `query GetCommPrefTRACCustomer {
    getCommPrefTRACCustomer {
      customerId
      consentClientId
      internetServerName
      electronicDeliveryAddressType
      electronicStatementFormat
      emailAddress
      informedConsentFormReceived
      hasConsent
      consentLastMaintenanceTimestamp
      alertSelections {
        hasPendingActivity
        hasAddressChange
        hasBankInstructionsChange
        mobile
      }
      statementSelections {
        type
        hasAdditionalPaperCopy
        hasNotification
        hasCustomerConsent
        hasElectronicDelivery
        lastMaintenanceTimestamp
        name
      }
    }
  }`,
  meta: {
    label: "Get TRAC Communication Preference",
  },
};

export default gql;
